var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossBlackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.545,
    height: 20.545,
    viewBox: "0 0 20.545 20.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Close_1473861",
    transform: "translate(-5.375 -5.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63865",
    "data-name": "Path 63865",
    d: "M18.243,15.648,25.391,22.8a1.835,1.835,0,1,1-2.6,2.6l-7.148-7.148L8.5,25.368a1.835,1.835,0,1,1-2.6-2.6l7.148-7.148L5.9,8.5A1.835,1.835,0,0,1,8.5,5.9l7.148,7.148L22.773,5.9a1.835,1.835,0,0,1,2.6,2.6Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlackIcon);
export default __webpack_public_path__ + "static/media/cross_black_icon.5ea6367944774abd8e2f7deb17431817.svg";
export { ForwardRef as ReactComponent };